// AmazingProductsSctSk.jsx
import { Container, Skeleton, Stack, Box } from "@mui/material";
import React from "react";

export default function AmazingProductsSk() {
  return (
    <Box sx={{ position: "relative", width: "100%", mt: "15rem" }}>
      <Container maxWidth="exl">
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            position: "relative",
            p: "1rem",
          }}
        >
          {/* Title + Button */}
          <Stack sx={{ textAlign: "center", width: "200px" }}>
            <Skeleton variant="text" width={120} height={35} />
            <Skeleton
              variant="text"
              width={160}
              height={35}
              sx={{ mb: "2rem" }}
            />
            <Skeleton
              variant="rounded"
              width={150}
              height={50}
              sx={{ mx: "auto" }}
            />
          </Stack>

          {/* Items Row Skeleton */}
          <Stack
            direction="row"
            sx={{
              gap: "1rem",
              position: "absolute",
              left: "2rem",
              bottom: "1rem",
            }}
          >
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                variant="rounded"
                width={250}
                height={350}
                sx={{ borderRadius: "1rem" }}
              />
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
